class PlugTestimonials extends HTMLElement {
    constructor() {
        super();
        window.PLUG.utils.bindThisToAllMethods(this);
        this.elements = {
            slider: this.querySelector(".plug-testimonials__slider"),
            slides: this.getElementsByClassName("swiper-slide"),
        };
    }

    connectedCallback() {
        if (this.dataset.blockInit !== "true") {
            this.init();
        }
    }

    init() {
        this.dataset.blockInit = "false";
        this.slider = this.initSlider();

        window.PLUG.utils.afterNextFrame(async () => {
            this.elements.slider.closest(".plug-testimonials__inner").classList.remove("is-see-through");
        });

        // const resizeDebounce = window.PLUG.utils.debounce(this.handleResize, 300);
        // window.addEventListener("resize", () => {
        //     resizeDebounce();
        // });
    }

    initSlider() {
        return new window.Swiper(".plug-testimonials__slider-wrapper", {
            modules: window.PLUG.swiperModules,
            direction: "horizontal",
            loop: false,
            slidesPerView: 1,
            spaceBetween: 20,
            autoHeight: true,
            pagination: {
                clickable: true,
                el: '.plug-testimonials-swiper-pagination',
                type: 'bullets',
            },
            resistanceRatio: 0.65,

            navigation: {
                nextEl: ".plug-testimonials-button-next",
                prevEl: ".plug-testimonials-button-prev",
                lockClass: "hidden"
            },
        });
    }
}

customElements.define("plug-testimonials", PlugTestimonials);